// extracted by mini-css-extract-plugin
export var card = "Hero-module--card--2be87";
export var float = "Hero-module--float--a5d5b";
export var innerStack = "Hero-module--innerStack--b429f";
export var scrollArrow = "Hero-module--scrollArrow--b03d3";
export var scrollIndicator = "Hero-module--scrollIndicator--5e8f7";